import { ReactNode } from 'react'
import { Upload } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { Project } from '@/types/projects'
import { useFileUploadContext } from '../upload-files/FileUploadProvider'
import DropZone from './DropZone'

type ProjectCardDropZoneProps = {
  children: ReactNode
  project: Project
  enabled: boolean
}

export default function ProjectCardDropZone({
  children,
  project,
  enabled,
}: ProjectCardDropZoneProps) {
  const { handleFilesSelectedToUpload } = useFileUploadContext()

  if (!enabled || project.setup_state !== 'complete') return <>{children}</>

  return (
    <DropZone
      onDrop={handleFilesSelectedToUpload}
      overlayChildren={
        <Stack
          sx={{
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#0008',
          }}
        >
          <Upload sx={{ fontSize: 36 }} />
          <Typography variant="body1" textAlign="center">
            Upload Documents
          </Typography>
        </Stack>
      }
    >
      {children}
    </DropZone>
  )
}
